// Using V2 scenes for the rework menu flow
import { Boot } from './scenes_v2/Boot';
import { GamaruSplash } from './scenes_v2/GamaruSplash';
import { GameOver } from './scenes_v2/GameOver';
import { Game as MainGame } from './scenes_v2/Game';
import { MainMenu } from './scenes_v2/MainMenu_v2';
import { LevelSelect } from './scenes_v2/LevelSelect';
import { LevelPreloader } from './scenes_v2/LevelPreloader';
import { LevelWin } from './scenes_v2/LevelWin';
import { WeaponWorkshop } from './scenes_v2/WeaponWorkshop';
import { ShipWorkshop } from './scenes_v2/ShipWorkshop';
import { Tutorial } from './scenes_v2/Tutorial';
import { Credits } from './scenes_v2/Credits';
import { Trophies } from './scenes_v2/Trophies';
import * as Phaser from 'phaser';
import { AUTO, Game } from 'phaser';
import { Preloader } from './scenes_v2/Preloader';
import { Configuration } from './scenes_v2/Configuration';
import { rexUIConfig } from './core/RexPlugins';
import { initDebugTools, setDebugGameInstance } from './core/Debug';

//  Find out more information about the Game Config at:
//  https://docs.phaser.io/api-documentation/typedef/types-core#gameconfig
const config: Phaser.Types.Core.GameConfig = {
  type: AUTO,
  parent: 'game-container',
  backgroundColor: '#0d1f33',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: 1600,
    height: 900,
  },
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  plugins: {
    scene: [rexUIConfig]
  },
  scene: [Boot, GamaruSplash, Preloader, MainMenu, Configuration, Credits, Trophies, LevelSelect, LevelPreloader, WeaponWorkshop, ShipWorkshop, Tutorial, MainGame, GameOver, LevelWin],
};

const StartGame = (parent: string) => {
  const game = new Game({ ...config, parent });
  setDebugGameInstance(game);
  return game;
};

document.addEventListener('DOMContentLoaded', () => {
  initDebugTools();
  StartGame('game-container');
});
